// extracted by mini-css-extract-plugin
export default {"container":"CardDetail_container__Mpd18","release_note":"CardDetail_release_note__sWkUf"};